import { useCallback, useEffect } from 'react';
import storeActions from '../actions';
import storeSelectors from '../selectors';
import { useAppDispatch } from 'store/hooks';
import { IApiGetListScreensInStoreParam } from 'modules/store/interfaces/api';

const useGetScreensInStore = (storeId: string) => {
  const dispatch = useAppDispatch();
  const screensListInStore = storeSelectors.getScreenListInStore();

  const mutate = useCallback((params: IApiGetListScreensInStoreParam) => {
      dispatch(storeActions.getListScreensInStore.fetch({ ...params, storeId }));
    },
    [dispatch, storeId]
  );

  useEffect(() => {
    mutate({
      page: 1,
      size: 1000,
    });
  }, [mutate]);

  return {
    screensListInStore,
    mutate,
  };
};

export default useGetScreensInStore;
